import React, { useState, useEffect, useRef } from 'react';
import { Card } from '@mui/material';
import Loader from '../components/Loader';
import { ShowError } from "../alerts/Error";
import { useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { setSelectedOption, updateResumenProperty} from '../globalslice';
import Transferencia from '../components/Configuracion/Transferencia';
import CartSteps from '../components/CartSteps';
import interrogationImg from '../images/interrogation.svg'
import addHosting from '../images/add-hosting.svg'

const TransferSearch = () => {
const { t } = useTranslation();
const [loader, setLoader] = useState(true);
const initialized = useRef(false)
const navigate = useNavigate();
const searchParams = new URLSearchParams(window.location.search);
const initialDomain = searchParams.has('domain') 
? searchParams.get('domain').replace(/\//g, '') 
: null;
const [currentDomain, setCurrentDomain] = useState(initialDomain);
const dispatch = useDispatch();
const resumenData = useSelector(state => state.global.ResumenData);
const urlV4 = process.env.REACT_APP_V4_BASE_URL

const redirectToErrorView = () => {
    const urlV4 = process.env.REACT_APP_V4_BASE_URL;
    window.location.replace(urlV4);
  };

  useEffect(() => {
    //Establece la opción de transferencia de configuración como principal
    dispatch(setSelectedOption('opc-trans'));
    if (!initialized.current) {
        initialized.current = true
        setLoader(false)
        if(currentDomain != null){
            setLoader(false)
            // Verifica si el dominio ya existe en local
            const exists = resumenData.some(item => 
                item.actual === false && // Verificar si el dominio NO se está configurando
                item.product.domain_section.some(section => 
                    section.dominio_principal === currentDomain
                )
            );
            if(exists) {
                ShowError(undefined, "Error", t('domainsearch.errors.alreadydomain'))
                navigate('/checkout')
            }
        } else {
            redirectToErrorView()
        }
    }
  });

  return (
    <div className="col-md-7 col-sm-12 col-xs-12 cf-content">
        <CartSteps numberStep={1} />
        <h2 style={{marginTop: '32px'}}>{t('cart.transfer.title')}</h2>
        <p className='roboto'>{t('cart.transfer.text')}</p>

        <Card elevation={0} style={{  width: '100%'}}>
            <Loader open={loader} />   
            <Transferencia 
            currentDomain={currentDomain}
            productActual={{isTransfer: true}}
        />  
         <Card className='bsq-dominio active' style={{marginTop:16, marginBottom: 16, display: 'flex', textDecoration: 'none'}}
            component="a"
            href={urlV4}>
            <img src={addHosting} alt="question icon" height="21px" width="21px"/>
            <p style={{ marginLeft: 8}}>{ t('cart.config.domain.transfer.addDomain')}</p>
        </Card>
        <div className='disclaimer'>
            <img style={{marginBottom: 'auto', paddingTop: '8px'}} src={interrogationImg} alt="question icon" height="22px"/>
            <p>{ t('cart.config.domain.transfer.disclaimer')}</p>
        </div>
        </Card>  
    </div>
  )
}

export default TransferSearch